import React from 'react';

import PropTypes, { any } from 'prop-types';
import { required } from '../../../../utils/form-validation';
import Tip from '../../../Tip';
import {
    Textarea,
} from '../../../Form';

import styles from '../eventCreate.scss';
import { isPickleBallSportTypeEvent } from '../../../../utils/events';

const EventDetails = (props) => {
    const {
        field,
        formApi,
        isTemplate,
        sportTypeId,
    } = props;

    const isPickleballEvent = isPickleBallSportTypeEvent(sportTypeId);

    const { errors, asyncErrors, submitting } = formApi;

    const eventDetails = {
        placeholder: 'Think of this as an advertisement for your event - the more excitement you can create, the better! \n' +
            'Include the information below: \n' +
            '-   Give a brief description of your event to tell players why they should register \n' +
            '-   What is the minimum number of matches they will play (pending draw size)? \n' +
            '-   Will you play out full sets to 6 or use Fast4 scoring format? If you will use a tiebreaker for the 3rd set, let them know here!\n' +
            '-   Let players know when matches will start and how early they should arrive for check-in.\n' +
            '-   How will you place and group players into draws and determine seeding?\n' +
            '-   When will draws be posted?\n' +
            '-  If you are giving prizes, let them know who can expect to receive a prize and what the prizes are (i.e. trophies, free lesson, and gift cards)',
        tipContent: '<b>Pro Tip:</b> Include the following: ' +
            '\n' +
            '   -   Date/Location \n' +
            '   -   Health & Safety Protocols \n' +
            '   -   Guaranteed Matches \n' +
            '   -   Scoring Format \n' +
            '   -   Time \n' +
            '   -   Event Format \n' +
            '   -   Prizes (optional)',
    };

    if (isPickleballEvent) {
        eventDetails.placeholder = 'Think of this as an advertisement for your event - the more excitement you can create, the better! \n' +
            'Include the information below: \n' +
            '-   Give a brief description of your event to tell players why they should register \n' +
            '-   What is the minimum number of matches they will play (pending draw size)? \n' +
            '-   Let players know when matches will start and how early they should arrive for check-in.\n' +
            '-   How will you place and group players into draws and determine seeding?\n' +
            '-   When will draws be posted?\n' +
            '-  If you are giving prizes, let them know who can expect to receive a prize and what the prizes are (i.e. trophies, free lesson, and gift cards)';
    }

    return (
        <div className="col-12">
            <div className="form-block-divider">
                <Tip
                    variant="info"
                    dangerouslySetInnerHTML={true}
                    customStyle={{ top: '42%', whiteSpace: 'pre' }}
                    content={eventDetails.tipContent}
                    showTip={!isTemplate}
                >
                    <Textarea
                        className={`${styles.textarea}`}
                        label="Event details"
                        description="This message will appear publicly on the tournament event page."
                        id="details"
                        field={field}
                        rows="10"
                        placeholder={eventDetails.placeholder}
                        validate={required}
                        errors={errors}
                        asyncErrors={asyncErrors}
                        submitting={submitting}
                    />
                </Tip>
            </div>
        </div>
    );
};

EventDetails.propTypes = {
    field: PropTypes.string.isRequired,
    formApi: PropTypes.objectOf(any).isRequired,
    isTemplate: PropTypes.bool,
    sportTypeId: PropTypes.number.isRequired,
};

EventDetails.defaultProps = {
    isTemplate: false,
};

export default EventDetails;
